export default "__VITE_ASSET__5a773655__"